var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.767 0 0 10.767 0 24s10.767 24 24 24 24-10.767 24-24S37.233 0 24 0zm0 46C11.869 46 2 36.131 2 24S11.869 2 24 2s22 9.869 22 22-9.869 22-22 22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.286 22.304L19.06 13.412a1.981 1.981 0 00-1.056-.307c-1.042 0-2.004.831-2.004 2.003v17.783c0 1.172.963 2.003 2.004 2.003.354 0 .718-.096 1.056-.307l14.226-8.892c1.254-.782 1.254-2.608 0-3.391zM18 32.891l.008-17.778L32.226 24 18 32.891z"
  })));
};
export default SvgPlay;